import React, { useState, useEffect, useRef } from "react";
import CustomInput from "../../CustomComponents/FormInputs";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
// import { LuClock3 } from "react-icons/lu"; 
import Check from '../../../assets/images/Check.png';
import Error from '../../../assets/images/Error.png';
import { useNavigate } from 'react-router-dom';
import TimerIcon from '../../../assets/images/timer.png';
import Oops from '../../../assets/images/Oops.png';
import { CHECKING_CARD_CODE } from "../../../helpers/utils/Utils";
import FieldLabel from "../FieldLabel";


//redux 
import app_env from '../../../utils/app-config.json';
import { GetApiHeadersWithBearer, GetApiHeadersWithOutBearer, PostRequest } from '../../../network/NetworkUtils';
import { useSelector, connect, useDispatch } from 'react-redux';
import { STATUS_SUCCESS_CODE, SIGNUP_VERIFY_NEW_ACCOUNT, VERIFY_OTP_BILLER,EMAIL_OTP_GENERATION, VERIFY_OTP_EXISTING_PHONE_EMAIL_NUMBER, RESEND_EXISTING_PHONE_EMAIL_NUMBER, OTP_USERS, RESENT_OTP_CHANGE_PIN, VERIFY_CHANGE_PIN, VERIFY_OTP_VIEW_CARD, RESEND_OTP_VIEW_CARD, VERIFY_OTP_ACTIVATE_CARD, RESEND_ACTIVATE_CARD_OTP, VERIFY_UPDATE_ADDRESS_OTP, VERIFY_UPDATE_EMAIL_OTP, VERIFY_OTP_UPDATE_PHONE_NUMBER, RESEND_UPDATE_PHONE_NUMBER, RESEND_UPDATE_EMAIL_OTP, RESEND_UPDATE_ADDRESS_OTP, VERIFY_OTP_CHANGE_PASSWORD, RESEND_CHANGE_PASSWORD_TOP, RESEND_OTP_ADD_AUTH_USER, VERIFY_OTP_ADD_AUTH_USER, VERIFY_OTP_KYC_CIP, GENERATE_EXISTING_PHONE_EMAIL_OTP, VERIFY_OTP_UNLOCK_CARD, RESEND_UNLOCK_CARD_OTP, GENERATE_OTP_KYC_CIP, RESEND_OTP_ADD_ACH_ACCOUNT, VERIFY_OTP_ADD_ACH_ACCOUNT, TWO_AUTH_VERIFY_OTP, GENERATE_OTP, VERIFY_UPGRADE_PLUS_OTP, RESEND_UPGRADE_PLUS_OTP, RESEND_DOWNGRADE_PLUS_OTP, VERIFY_DOWNGRADE_OTP, CONTACT_US_URL, VERIFY_OTP_SECURED_CREDIT_CARD, RESEND_OTP_SECURED_CREDIT_CARD } from '../../../network/URLConstants';
import Loader from "../../CustomComponents/Loader";
import { displayErrorMessage, displayKudzuplusErrorMessage } from '../../../utils';
import { appTheme, retrieveData } from '../../../helpers/utils/Utils';
import { fetchConfigarationData } from "../../../helpers/utils/Utils";
import { useKeyDown } from "../../../hooks/useKeyDown";
import { LOGIN_SESSION_KEY } from "../../../Redux/reducers";
import logFirebaseEvents from "../../LogFirebaseEvents";
import { VERIFY_OTP_SCH } from "../../../network/URLConstants";
import { SCH_RESEND_OTP } from "../../../network/URLConstants";
import { formatDateYYYYMMDDFORSCH } from "../../../utils";
import { selectHasKudzuCard } from "../../../Redux/selectors";

// const appConfigData = await fetchConfigarationData();
var verifyResponse = {}
export const Custom2FA = (props) => {
    const { openPhoneOTPModal, onClose, upgradeInputBg, verificationSuccess, verificationFailure, type, email, phoneNumber, address, bottomText } = props
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const hasKudzuCard = useSelector(selectHasKudzuCard);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const selectedItem = (cards != null && cards != undefined && cards.length != 0) ? cards[0] : {}
    const spendingCardKey = (cards != null && cards != undefined && cards.length != 0) ? cards?.find((item) => (item?.AccountTypeBit63 == (hasKudzuCard ? 64 : 1))).CardKey : 0
    const { t } = useTranslation();
    const accessTokenToApi = useSelector(state => state.accessToken);
    const sessionId = useSelector(state => state.sessionId);
    const userId = useSelector(state => state.userId);
    const [isValid, setvalidCode] = useState(false);
    const [verifyCode, setCode] = useState(''); // State variable to store the input value
    const [localSessionId, setlocalSessionId] = useState('');
    const [message, setMessage] = useState('');
    // const [verifyResponse, setVerifyResponse] = useState({});
    const [resendCount, setResendCount] = useState(1);
    const appConfigData = useSelector(state => state.appConfigData);
    const sessionKey = useSelector(state => state.loggedSessionKey);
    const addOnCardRequestId = useSelector(x => x.schAddOnCardId)
    const deviceIdNew = useSelector(state => state.deviceId);
    const cardDetails = useSelector(state => state.selectedCardDetails);
    const isTrusted = useSelector(state => state.isDeviceTrustedPayload);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const isB2c = useSelector(state => state.preferredIdentity);
    const inputRef = useRef(null);
    const submitButtonRef = useRef(null);
    const [timer, setTimer] = useState(30);
    const [startTimer, setStartTimer] = useState(false);
    const [isCodeFocused, setIsCodeFocused] = useState(false);
    const appThemeData = appTheme(kudzuPlusTrue)
    const primaryCardKey = cards?.find((item) => (item?.AccountTypeBit63 == 1))?.CardKey;
    const phoneNumberSCH = useSelector(x => x.secondaryCardPhoneNumber)
    const schEmail = useSelector(x => x.secondaryCardEmail)
    
   // rppsBiller
    const selectedBiller = useSelector(con => con.selectedBillerType);
    const enteredAccountNumber = useSelector(con => con.enteredAccountNumber);
    const selectedFrequencyType = useSelector(con => con.selectedFrequencyType);
    const billPaymentOneTimeDate = useSelector(con => con.billPaymentOneTimeDate);
    const billPaymenRCStartDate = useSelector(con => con.billPaymenRCStartDate);
    const billPaymenRCEndDate = useSelector(con => con.billPaymenRCEndDate);
    const billAmount = useSelector(con => con.billAmount);


    // new biller 
    const newBillerName = useSelector(con => con.newBillerName);
    const newAccountNumber = useSelector(con => con.newAccountNumber);
    const billerAddressOne = useSelector(con => con.billerAddressOne);
    const billerAddressTwo = useSelector(con => con.billerAddressTwo);
    const billerAddressCity = useSelector(con => con.billerAddressCity);
    const billerAddressZipCode = useSelector(con => con.billerAddressZipCode);
    const billerAddressStates = useSelector(con => con.billerAddressStates);
    const billerAddressCuntries = useSelector(con => con.billerAddressCuntries);
    const billerAddressPhone = useSelector(con => con.billerAddressPhone);
    const newBillerFrequency = useSelector(con => con.newBillerFrequency);
    const newBillerOneTimeDate = useSelector(con => con.newBillerOneTimeDate);
    const newBillerRcStartDate = useSelector(con => con.newBillerRcStartDate);
    const newBillerRcEndDate = useSelector(con => con.newBillerRcEndDate);
    const newBillerAmount = useSelector(con => con.newBillerAmount);

    // modify biller redux states
    const modifyBillerName = useSelector(s => s.modifyBillerName);
    const modifyAccNumber = useSelector(s => s.modifyAccNumber);
    const modifyLine1 = useSelector(s => s.modifyLine1);
    const modifyLine2 = useSelector(s => s.modifyLine2);
    const modifyCity = useSelector(s => s.modifyCity);
    const modifyStates = useSelector(s => s.modifyStates);
    const modifyZipCode = useSelector(s => s.modifyZipCode);
    const modifyCountry = useSelector(s => s.modifyCountry);
    const modifyPhone = useSelector(s => s.modifyPhone);
    const modifyFrequency = useSelector(s => s.modifyFrequency);
    const modifyAmount = useSelector(s => s.modifyAmount);
    const modifyOneTimeDate = useSelector(s => s.modifyOneTimeDate);
    const modifyStartDate = useSelector(s => s.modifyStartDate);
    const modifyEndDate = useSelector(s => s.modifyEndDate);
    const modifySVAKey = useSelector(x => x.modifySvaBillerKey)
    const modifyBillerId = useSelector(x => x.modifyBillerID)

    useEffect(() => {

        if (startTimer) {
            if (timer > 0) {
                setTimeout(() => {
                    setTimer(prev => prev - 1);
                }, 1000)
            }
            else setStartTimer(false);
        }
    }, [timer, startTimer])

    useEffect(() => {
        if (props?.type == t('fraud_protection')) setStartTimer(true)
    }, [])


    const schema = yup.object().shape({
        verifyCode: yup
            .string()
            .required(t('otp_required'))
            .matches(/^\d{6}$/, t('otp_required')),
    });
    useEffect(() => {
        if (sessionId != null && sessionId != '' && userId != null && userId != '') {
        }
    }, [sessionId, userId])

    const [isLoading, setIsLoading] = useState(false);
    const handleVerifyCodeChange = async (event) => {
        setMessage('');
        const { name, value } = event.target;
        setCode(value);
        setvalidCode(false);
        try {
            await schema.validate({ [name]: value });
            setvalidCode(true);
            setCode(value);
            setMessage(''); // Clear the message when input value is valid
        } catch (error) {
            setvalidCode(false);
        }
    };
    const {
        register,
        formState: { errors },
        setValue
    } = useForm({
        resolver: yupResolver(schema),
    });
    useEffect(() => {
        if (verifyCode.length === 6 && submitButtonRef.current) {
            //     // Focus on the submit button when 6 digits are entered
            submitButtonRef.current.focus();
        }

    }, [verifyCode])
    // useKeyDown(() => {
    //     handleVerify()
    // }, ["Enter"]);

    const getHeadersWithBearerOrWithoutBearer = async () => {

        const deviceId = await retrieveData('updatedDeviceId')
        let headers;

        switch (type) {

            case t('view_card_details'):
            case t('unlock_card'):
            case t('change_pin'):
            case t('add_external_account'):
            case t('old_mobile'):
            case t('old_email'):
            case t('old_address'):
            case t('replace_card'):
            case t('activate_card'):
            case t('new_mobile'):
            case t('new_email'):
            case t('new_address'):
            case t('change_password'):
            case t('google'):
            case t('facebook'):
            case t('microsoft'):
            case t('add_auth_user'):
            case t('apple_id'):
            case t('sch_mobile'):
            case t('sch_email'):
            case t('sch_mobile_update'):
            case t('sch_email_update'):
            case t('secured_credit_card'):
            case t('rpps_biller'):
            case t('paper_biller'): 
            case t('modify_paper'):
            case t('modify_rpps'):       
                headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
                break;
            case t('fraud_protection'):
                headers = await GetApiHeadersWithOutBearer();
                break;
            case t('upgrade_to_kduzu_plus'):
                headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
                break;
            case t('downgrad_to_kudzu_plus'):
                headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
                break;
            default:
                headers = await GetApiHeadersWithOutBearer();
                break;
        }

        return headers;
    }
    const onSubmit = async (data) => {
        const deviceId = await retrieveData('updatedDeviceId')
        setIsLoading(true)
        let headers = await getHeadersWithBearerOrWithoutBearer(type);
        let requestObj;
        let url;
        switch (type) {
            case t('fraud_protection'):
                requestObj = {
                    "lang": "en",
                    "appID": appConfigData.CLIENT_ID,
                    "otp": data.verifyCode,
                    "code": props?.accessParam,
                    "sessionkey": sessionKey,
                }
                url = VERIFY_OTP_KYC_CIP
                break;
            case t('unlock_card'):
                requestObj = {
                    "code": data.verifyCode,
                    "sessionId": sessionKey,
                    "cardKey": cardDetails.CardKey
                }
                url = VERIFY_OTP_UNLOCK_CARD
                break;
            case t('change_password'):
                requestObj = {
                    "mobileNumber": phoneNumber,
                    "cardKey": selectedItem.CardKey,
                    "sessionId": sessionKey,
                    "code": data.verifyCode

                }
                url = VERIFY_OTP_CHANGE_PASSWORD
                break;

            case t('old_mobile'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey,
                    "action": "mobile"
                }
                url = VERIFY_OTP_EXISTING_PHONE_EMAIL_NUMBER
                break;
            case t('new_mobile'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey,
                    "mobileNumber": phoneNumber
                }
                url = VERIFY_OTP_UPDATE_PHONE_NUMBER(isB2c)
                break;
            case t('old_email'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey,
                    "action": "email"
                }
                url = VERIFY_OTP_EXISTING_PHONE_EMAIL_NUMBER
                break;
            case t('new_email'):
                requestObj = {
                    "email": email,
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey,
                }
                url = VERIFY_UPDATE_EMAIL_OTP(isB2c)
                break;
            case t('old_address'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey,
                    "action": "address"
                }
                url = VERIFY_OTP_EXISTING_PHONE_EMAIL_NUMBER
                break;
            case t('new_address'):
                var object = {};
                object = address;
                object.sessionId = sessionKey;
                // object.cardKey = selectedItem.CardKey;
                requestObj = object;
                url = VERIFY_UPDATE_ADDRESS_OTP
                break;
            case t('add_external_account'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey,
                    "action": "mobile"
                }
                url = VERIFY_OTP_ADD_ACH_ACCOUNT
                break;
            case t('replace_card'):
                requestObj = {
                    "ActionType": "MFAVerification",
                    "SessionKey": sessionKey,
                    "OTP": data.verifyCode,
                    "DeviceID": deviceId,
                    "IsTrustedDevice": isTrusted,
                };

                url = TWO_AUTH_VERIFY_OTP + "?CardKey=" + cardDetails?.CardKey;
                break;
            case t('change_pin'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey,
                }
                url = VERIFY_CHANGE_PIN
                break;
            case t('view_card_details'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey,
                }
                url = VERIFY_OTP_VIEW_CARD
                break;
            case t('activate_card'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey,
                }
                url = VERIFY_OTP_ACTIVATE_CARD
                break;
            case t('google'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "applicationId": appConfigData.CLIENT_ID,
                    "language": 'en'
                }
                url = OTP_USERS + userId + '/emails/' + sessionKey + '/verify'
                break;
            case t('facebook'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "applicationId": appConfigData.CLIENT_ID,
                    "language": 'en'
                }
                url = OTP_USERS + userId + '/emails/' + sessionKey + '/verify'
                break;
            case t('microsoft'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "applicationId": appConfigData.CLIENT_ID,
                    "language": 'en'
                }
                url = OTP_USERS + userId + '/emails/' + sessionKey + '/verify'
                break;
            case t('add_auth_user'):

                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey,
                }
                url = VERIFY_OTP_ADD_AUTH_USER
                break;
            case t('apple_id'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "applicationId": appConfigData.CLIENT_ID,
                    "language": 'en'
                }
                url = OTP_USERS + userId + '/emails/' + sessionKey + '/verify'
                break;
            case t('upgrade_to_kduzu_plus'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey
                }
                url = VERIFY_UPGRADE_PLUS_OTP
                break;
            case t('downgrad_to_kudzu_plus'):
                requestObj = {
                    "sessionId": sessionKey,
                    "code": data.verifyCode,
                    "cardKey": spendingCardKey
                }
                url = VERIFY_DOWNGRADE_OTP
                break;
            case 'sch_mobile':
                requestObj = {
                    "SessionKey": sessionKey,
                    "OTP": data.verifyCode,
                    "ActionType": "SecondaryCardRequest",
                    "SecondaryCardRequest": {
                        "Mobile1": phoneNumberSCH,
                        "ID": String(addOnCardRequestId)
                    }
                }
                url = VERIFY_OTP_SCH(primaryCardKey)
                break;
            case 'sch_email':
                requestObj = {
                    "SessionKey": sessionKey,
                    "OTP": data.verifyCode,
                    "ActionType": "SecondaryCardRequest",
                    "SecondaryCardRequest": {
                        "EmailID": schEmail,
                        "ID": String(addOnCardRequestId)
                    }
                }
                url = VERIFY_OTP_SCH(primaryCardKey)
                break;
            case 'sch_mobile_update':
                requestObj = {
                    "SessionKey": sessionKey,
                    "OTP": data.verifyCode,
                    "ActionType": "SecondaryCardRequest",
                    "SecondaryCardRequest": {
                        "Mobile1": phoneNumber,
                        "ID": String(addOnCardRequestId)
                    }
                }
                url = VERIFY_OTP_SCH(primaryCardKey)
                break;
            case 'sch_email_update':
                requestObj = {
                    "SessionKey": sessionKey,
                    "OTP": data.verifyCode,
                    "ActionType": "SecondaryCardRequest",
                    "SecondaryCardRequest": {
                        "EmailID": email,
                        "ID": String(addOnCardRequestId)
                    }
                }
                url = VERIFY_OTP_SCH(primaryCardKey)
                break;
            case t('secured_credit_card'):
                requestObj = {
                    "sessionId": sessionKey,
                    "OTP": data.verifyCode,
                    "code": data.verifyCode,
                    "cardKey": selectedItem.CardKey,
                }
                url = VERIFY_OTP_SECURED_CREDIT_CARD + '?cardKey=' + selectedItem.CardKey + '&sessionId=' + sessionKey
                break;
            case t('rpps_biller'):
                requestObj = {
                    "SessionKey": sessionKey,
                    "OTP": data.verifyCode,
                    "ActionType": "AddRPPSBiller",
                    "Biller": {
                        "BillerID": selectedBiller?.Type,
                        "BillerName": selectedBiller?.Name,
                        "AccountNumber": enteredAccountNumber,
                        "ReferenceName": "",
                        "FrequencyType": selectedFrequencyType?.Type,
                        "NextDate": selectedFrequencyType?.Type === "O" ? formatDateYYYYMMDDFORSCH(billPaymentOneTimeDate) : formatDateYYYYMMDDFORSCH(billPaymenRCStartDate),
                        "EndDate": selectedFrequencyType?.Type === "O" ? formatDateYYYYMMDDFORSCH(billPaymentOneTimeDate) : formatDateYYYYMMDDFORSCH(billPaymenRCEndDate),
                        "Amount": billAmount
                    }
                }
                url = VERIFY_OTP_BILLER(primaryCardKey)
                break; 
             case t('paper_biller'):
                requestObj = {
                    "SessionKey": sessionKey,
                    "OTP": data.verifyCode,
                    "ActionType": "AddPaperBiller",
                    "Biller": {
                       "BillerName": newBillerName,
                        "AccountNumber": newAccountNumber,
                        "Amount": newBillerAmount,
                        "NextDate": newBillerFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(newBillerOneTimeDate) : formatDateYYYYMMDDFORSCH(newBillerRcStartDate),
                        "EndDate": newBillerFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(newBillerOneTimeDate) : formatDateYYYYMMDDFORSCH(newBillerRcEndDate),
                        "FrequencyType": newBillerFrequency?.Type,
                        "Line1": billerAddressOne,
                        "Line2": billerAddressTwo,
                        "City": billerAddressCity,
                        "StateCode": billerAddressStates?.Type,
                        "CountryCode": billerAddressCuntries?.Type,
                        "ZipCode": billerAddressZipCode,
                        "PhoneNumber": billerAddressPhone
                    }
                }
                url = VERIFY_OTP_BILLER(primaryCardKey)
                break;
            case t('modify_paper'):
                requestObj = {
                    "SessionKey": sessionKey,
                    "OTP": data.verifyCode,
                    "ActionType": "ModifyPaperBiller",
                    "Biller": {
                        "AccountNumber": modifyAccNumber,
                        "Amount": modifyAmount,
                        "BillerName": modifyBillerName,
                        "City": modifyCity,
                        "CountryCode": modifyCountry?.Type,
                        "FrequencyType": modifyFrequency?.Type,
                        "Line1": modifyLine1,
                        "Line2": modifyLine2,
                        "PhoneNumber": modifyPhone,
                        "SVABillerKey": modifySVAKey,
                        "BillerID": "",
                        "StateCode": modifyStates?.Type,
                        "ZipCode": modifyZipCode,
                        "NextDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyStartDate),
                        "EndDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyEndDate),
                    }
                }
                url = VERIFY_OTP_BILLER(primaryCardKey)
                break; 
             case t('modify_rpps'):
                requestObj = {
                    "SessionKey": sessionKey,
                    "OTP": data.verifyCode,
                    "ActionType": "ModifyRPPSBiller",
                    "Biller": {
                        "AccountNumber": modifyAccNumber,
                        "Amount": modifyAmount,
                        "BillerName": modifyBillerName,
                        "FrequencyType": modifyFrequency?.Type,
                        "SVABillerKey": modifySVAKey,
                        "BillerID": modifyBillerId,
                        "NextDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyStartDate),
                        "EndDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyEndDate),
                    }
                }
                url = VERIFY_OTP_BILLER(primaryCardKey)
                break;            
            

            default:

                break;
        }
        var response = await PostRequest(url, requestObj, headers);
        let responseObj = JSON.parse(response);
        if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {

            setIsLoading(false)
            verifyResponse = responseObj
            return true;
        } else {
            verifyResponse = responseObj
            setIsLoading(false)
            var arrMessages = responseObj.Messages;
            if (arrMessages.length > 0) {
                var messageObject = arrMessages[0];
                const message = messageObject.DisplayText;
                const formattedMessage = "<span className='font-hanken-grotesk text-md leading-7 text-oops_error pr-2'>Oops! </span>" + message;
                setMessage(message);
                setvalidCode(false);

            }
        }
    };

    // useEffect(() => {
    // }, [verifyCode]) 

    const handleVerifyButton = () => {
        if (verifyCode.length == 6 && isValid !== false) {
            navigate('/kudzuplusterms')
        }

    }
    const handleVerify = async () => {
        logFirebaseEvents("Personal_Information", "Verify_Otp_Clicked", "Verify_Otp_Clicked", "", "");
        if (verifyCode.length == 6 && isValid !== false) {
            const success = await onSubmit({ verifyCode }); // Call onSubmit function and pass the input value 
            if (success) {
                const twoFactAuthenticationDone = { twoFactAuthenticationDone: true }
                dispatch({ type: 'TWOFACT_DONE', payload: twoFactAuthenticationDone });
                onClose();
                setTimeout(() => {
                    verificationSuccess(type, verifyResponse);
                    verifyResponse = {}
                }, 500);

            } else {
                setCode('');
                verificationFailure(type, verifyResponse);
                verifyResponse = {}
            }
        } else {
            if (verifyCode.length === 0) {
                setMessage(t('otp_required'));
            } else {
                setMessage(t('Invalid_Verification_Code'));
            }
        }
    };

    const resendVerificationCode = async () => {
        const deviceId = await retrieveData('updatedDeviceId')
        setValue('verifyCode', '');
        const otpresendNumber = resendCount;
        if (otpresendNumber >= 4) {
            setMessage(t('exceeded_max_limit'))
            return;
        }
        setIsLoading(true)
        let headers = await getHeadersWithBearerOrWithoutBearer(type);
        let requestObj;
        let url;
        switch (type) {
            case t('fraud_protection'):
                requestObj = {
                    "lang": "en",
                    "appID": appConfigData.CLIENT_ID,
                    "code": props?.accessParam,
                    "sessionkey": sessionKey,
                }
                url = GENERATE_OTP_KYC_CIP
                break;
            case t('add_external_account'):
                requestObj = {
                    "applicationId": appConfigData.CLIENT_ID,
                    "language": "en"
                }
                url = RESEND_OTP_ADD_ACH_ACCOUNT.replace('{CARDKEY}', selectedItem.CardKey)
                break;
            case t('replace_card'): 
                requestObj = {
                    "SessionKey": sessionKey,
                    "ActionType": "MFAVerification",
                    "DeviceID": deviceId,
                };
                // url = RESEND_OTP_ADD_ACH_ACCOUNT.replace('{CARDKEY}', selectedItem.CardKey)
                url = GENERATE_OTP + "?CardKey=" + cardDetails?.CardKey;
                break;

            case t('old_mobile'):
                requestObj = {
                    // "applicationId": appConfigData.CLIENT_ID,
                    // "language": "en",
                    "cardKey": selectedItem.CardKey,
                    "action": "mobile"
                }
                url = RESEND_EXISTING_PHONE_EMAIL_NUMBER
                break;
            case t('unlock_card'):
                requestObj = {}
                url = RESEND_UNLOCK_CARD_OTP.replace('{cardKey}', `${cards?.[0]?.CardKey}`)
                break;
            case t('old_email'):
                requestObj = {
                    // "applicationId": appConfigData.CLIENT_ID,
                    "cardKey": selectedItem.CardKey,
                    "action": "email"
                    // "language": "en"
                }

                url = RESEND_EXISTING_PHONE_EMAIL_NUMBER
                break;
            case t('new_mobile'):
                requestObj = { "cardKey": selectedItem.CardKey }
                url = RESEND_UPDATE_PHONE_NUMBER
                break;
            case t('new_email'):
                requestObj = { "cardKey": selectedItem.CardKey }
                url = RESEND_UPDATE_EMAIL_OTP
                break;
            case t('old_address'):
                // requestObj = {
                //     "cardKey": selectedItem.CardKey,
                //     "action": "mobile"
                // }
                // url = RESEND_EXISTING_PHONE_EMAIL_NUMBER;
                requestObj = {
                    "action": "address",
                    "cardKey": selectedItem.CardKey
                }
                url = GENERATE_EXISTING_PHONE_EMAIL_OTP
                break;
            case t('new_address'):
                requestObj = { "cardKey": selectedItem.CardKey }
                url = RESEND_UPDATE_ADDRESS_OTP
                break;
            case t('change_pin'):
                requestObj = { "cardKey": selectedItem.CardKey }
                url = RESENT_OTP_CHANGE_PIN
                break;
            case t('view_card_details'):
                requestObj = { "cardKey": cardDetails.CardKey }
                url = RESEND_OTP_VIEW_CARD
                break;
            case t('activate_card'):
                requestObj = { "cardKey": selectedItem.CardKey }
                url = RESEND_ACTIVATE_CARD_OTP
                break;
            case t('add_auth_user'):
                url = RESEND_OTP_ADD_AUTH_USER.replace('{CARD_KEY}', selectedItem.CardKey)
                break
            case t('upgrade_to_kduzu_plus'):
                requestObj = {
                }
                url = RESEND_UPGRADE_PLUS_OTP.replace('{cardKey=0}', spendingCardKey);
                break;
            case t('downgrad_to_kudzu_plus'):
                requestObj = {
                }
                url = RESEND_DOWNGRADE_PLUS_OTP.replace('{cardKey=0}', spendingCardKey);
                break;
            case t('change_password'):
                requestObj = {}
                url = RESEND_CHANGE_PASSWORD_TOP.replace('{cardKey}', selectedItem.CardKey);
                break;
            case "sch_mobile":
                requestObj = {
                    "SessionKey": sessionKey,
                    "ActionType": "SecondaryCardRequest",
                    "SecondaryCardRequest": {
                        "Mobile1": phoneNumberSCH,
                        "ID": String(addOnCardRequestId)
                    }
                }
                url = SCH_RESEND_OTP(primaryCardKey);
                break;
            case "sch_email":
                requestObj = {
                    "SessionKey": sessionKey,
                    "ActionType": "SecondaryCardRequest",
                    "SecondaryCardRequest": {
                        "EmailID": phoneNumberSCH,
                        "ID": String(addOnCardRequestId)
                    }
                }
                url = SCH_RESEND_OTP(primaryCardKey)
                break;
            case "sch_mobile_update":
                requestObj = {
                    "SessionKey": sessionKey,
                    "ActionType": "SecondaryCardRequest",
                    "SecondaryCardRequest": {
                        "Mobile1": phoneNumber,
                        "ID": String(addOnCardRequestId)
                    }
                }
                url = SCH_RESEND_OTP(primaryCardKey);
                break;
            case "sch_email_update":
                requestObj = {
                    "SessionKey": sessionKey,
                    "ActionType": "SecondaryCardRequest",
                    "SecondaryCardRequest": {
                        "EmailID": email,
                        "ID": String(addOnCardRequestId)
                    }
                }
                url = SCH_RESEND_OTP(primaryCardKey)
                break;
            case t('secured_credit_card'):
                requestObj = { "cardKey": selectedItem.CardKey }
                url = RESEND_OTP_SECURED_CREDIT_CARD.replace('{CARD_KEY}', selectedItem.CardKey)
                break;
            case t('rpps_biller'):
                requestObj = {
                    "SessionKey": sessionKey,
                    "ActionType": "AddRPPSBiller",
                    "Biller": {
                        "BillerID": selectedBiller?.Type,
                        "BillerName": selectedBiller?.Name,
                        "AccountNumber": enteredAccountNumber,
                        "ReferenceName": "",
                        "FrequencyType": selectedFrequencyType?.Type,
                        "NextDate": selectedFrequencyType?.Type === "O" ? formatDateYYYYMMDDFORSCH(billPaymentOneTimeDate) : formatDateYYYYMMDDFORSCH(billPaymenRCStartDate),
                        "EndDate": selectedFrequencyType?.Type === "O" ? formatDateYYYYMMDDFORSCH(billPaymentOneTimeDate) : formatDateYYYYMMDDFORSCH(billPaymenRCEndDate),
                        "Amount": billAmount
                    }
                }
                url = GENERATE_OTP + "?CardKey=" + primaryCardKey;
                break;    
                  case t('paper_biller'):
                requestObj = {
                    "SessionKey": sessionKey,
                    "ActionType": "AddPaperBiller",
                    "Biller": {
                        "BillerName": newBillerName,
                        "AccountNumber": newAccountNumber,
                        "Amount": newBillerAmount,
                        "NextDate": newBillerFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(newBillerOneTimeDate) : formatDateYYYYMMDDFORSCH(newBillerRcStartDate),
                        "EndDate": newBillerFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(newBillerOneTimeDate) : formatDateYYYYMMDDFORSCH(newBillerRcEndDate),
                        "FrequencyType": newBillerFrequency?.Type,
                        "Line1": billerAddressOne,
                        "Line2": billerAddressTwo,
                        "City": billerAddressCity,
                        "StateCode": billerAddressStates?.Type,
                        "CountryCode": billerAddressCuntries?.Type,
                        "ZipCode": billerAddressZipCode,
                        "PhoneNumber": billerAddressPhone
                    }
                }
                url = GENERATE_OTP + "?CardKey=" + primaryCardKey;
                break;  
            case t('modify_paper'):
                requestObj = {
                    "SessionKey": sessionKey,
                    "ActionType": "ModifyPaperBiller",
                    "Biller": {
                        "AccountNumber": modifyAccNumber,
                        "Amount": modifyAmount,
                        "BillerName": modifyBillerName,
                        "City": modifyCity,
                        "CountryCode": modifyCountry?.Type,
                        "FrequencyType": modifyFrequency?.Type,
                        "Line1": modifyLine1,
                        "Line2": modifyLine2,
                        "PhoneNumber": modifyPhone,
                        "SVABillerKey": modifySVAKey,
                        "BillerID": "",
                        "StateCode": modifyStates?.Type,
                        "ZipCode": modifyZipCode,
                        "NextDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyStartDate),
                        "EndDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyEndDate),
                    }
                }
                url = GENERATE_OTP + "?CardKey=" + primaryCardKey;
                break;  
            case t('modify_rpps'):
                requestObj = {
                    "SessionKey": sessionKey,
                    "ActionType": "ModifyRPPSBiller",
                    "Biller": {
                        "AccountNumber": modifyAccNumber,
                        "Amount": modifyAmount,
                        "BillerName": modifyBillerName,
                        "FrequencyType": modifyFrequency?.Type,
                        "SVABillerKey": modifySVAKey,
                        "BillerID":  modifyBillerId,
                        "NextDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyStartDate),
                        "EndDate": modifyFrequency?.Type === "O" ? formatDateYYYYMMDDFORSCH(modifyOneTimeDate) : formatDateYYYYMMDDFORSCH(modifyEndDate),
                    }
                }
                url = GENERATE_OTP + "?CardKey=" + primaryCardKey;
                break;            
            default:
                break;
        }

        PostRequest(url, requestObj, headers).then((response) => {
            let parsedResponse = JSON.parse(response);
            if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {
                let sessionIdPayload;
                // const sessionIdPayload = { loggedSessionKey: parsedResponse.Response.sessionId }
                if (props?.type == t('fraud_protection')) {
                    sessionIdPayload = { loggedSessionKey: parsedResponse.Response.sessionKey }
                }
                else if (props?.type == t('replace_card')) {
                    sessionIdPayload = { loggedSessionKey: parsedResponse.Response.SessionKey }
                } else if (props?.type == "sch_mobile") {
                    sessionIdPayload = { loggedSessionKey: parsedResponse.Response.SessionKey }
                } else if (props?.type == "sch_email") {
                    sessionIdPayload = { loggedSessionKey: parsedResponse.Response.SessionKey }
                } else if (props?.type == "sch_mobile_update") {
                    sessionIdPayload = { loggedSessionKey: parsedResponse.Response.SessionKey }
                } else if (props?.type == "sch_email_update") {
                    sessionIdPayload = { loggedSessionKey: parsedResponse.Response.SessionKey }
                } else if (props?.type == t("rpps_biller")) {
                    sessionIdPayload = { loggedSessionKey: parsedResponse.Response.SessionKey }
                }
                else if (props?.type == t("paper_biller")) {
                    sessionIdPayload = { loggedSessionKey: parsedResponse.Response.SessionKey }
                }
                 else if (props?.type == t("modify_paper")) {
                    sessionIdPayload = { loggedSessionKey: parsedResponse.Response.SessionKey }
                }
                else if (props?.type == t("modify_rpps")) {
                    sessionIdPayload = { loggedSessionKey: parsedResponse.Response.SessionKey }
                }
                
                else sessionIdPayload = { loggedSessionKey: parsedResponse.Response.sessionId }
                // dispatch({ type: 'SESSION_ID', payload: sessionIdPayload });
                dispatch({ type: LOGIN_SESSION_KEY, payload: sessionIdPayload });
                setTimeout(() => {
                    const resendNumber = resendCount + 1;
                    setResendCount(resendNumber);
                    setMessage('')
                    setIsLoading(false)
                }, 500);

            } else {
                setTimeout(() => {
                    var arrMessages = parsedResponse.Messages;
                    var message = arrMessages[0];
                    var displayText = message.DisplayText;
                    setMessage(displayText);
                    setIsLoading(false)
                }, 500);

            }
        })

    }

    const handleResendCodeForCIP = () => {
        resendVerificationCode();
        setTimer(30);
        setStartTimer(true)
    }
    const handleSubmit = (event) => {

        if (verifyCode.length == 6) {
            event.preventDefault();
            handleVerify();
        }
    };

    return (
        <>
            <FieldLabel
                name="verifyCode"
                label={t('verification_code_label')}
                required={true}
            />

            <div className="flex flex-row sm:w-[375px] w-full items-center">
                <div className="w-1/2">
                    <CustomInput
                        name="verifyCode"
                        value={verifyCode}
                        label={t('verification_code_label')}
                        placeholder={t("verification_code_placeholder")}
                        register={register}
                        error={errors.verifyCode}
                        autoFocus={true}
                        type="6Code"
                        onChange={handleVerifyCodeChange}
                        isValid={isValid}
                        ref={inputRef}
                        upgradeInputBg={upgradeInputBg}
                        kudzuPlus={(props?.type == t('upgrade_to_kduzu_plus')) ? true : kudzuPlusTrue}
                        onFocus={() => setIsCodeFocused(true)}
                        onBlur={() => setIsCodeFocused(false)}
                    // onKeyDownFun={(event) => { if (event.key == "Enter") { event.preventDefault(); handleVerifyCodeChange(); event.target.style.opacity = 0.8; setTimeout(() => { event.target.style.opacity = 1; }, 200); } }}
                    />
                </div>            
                <div  className="w-1/2 mb-4">
                    <button
                        type={'submit'}
                        ref={submitButtonRef}
                        className="font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] w-full bg-submit-btn hover:bg-submit-btn text-white py-2 px-4 font-medium lg:h-[60px] md:h-[50px] sm:h-[45px] h-[50px] active:opacity-80 transition-opacity duration-200"
                        onClick={handleVerify}
                    >
                        {t('verify')}
                    </button>
                </div>
                <div className="ml-2 mb-4">
                    {!isCodeFocused && verifyCode.length > 0 && isValid && (
                        <img src={appThemeData.Check} className="w-4 h-4" alt="Valid" />
                    )}
                    {isCodeFocused && (
                        <img src={appThemeData.Pending} className="w-4 h-4" alt="Pending" />
                    )}
                    {!isCodeFocused && !isValid && (
                        <img src={appThemeData.ExclamationError} className="w-4 h-4" alt="Error" />
                    )}
                </div>
            </div>
            {message && (props?.type !== t('fraud_protection') && props?.type !== t('upgrade_to_kduzu_plus') && props?.type !== t('downgrad_to_kudzu_plus')) &&
                <div className='mb-2'>
                    {/* {displayErrorMessage(message)} */}
                    {kudzuPlusTrue ? displayKudzuplusErrorMessage(message) : displayErrorMessage(message)}

                </div>
            }

            {/* for kudzu memebership error */}
            {message && (props?.type === t('upgrade_to_kduzu_plus') || props?.type === t('downgrad_to_kudzu_plus')) &&
                <div className="flex sm:mx-0 flex-row gap-4 justify-start mt-8 mb-28">
                    <img src={Oops} alt="" className="md:w-[20px] md:h-[20px] sm:w-[14px]
        sm:h-[14px] w-[15px] h-[15px] mt-1 sm:mt-0 md:mt-1  self-start" />
                    <p className={`font-hanken-grotesk font-[500] text-[16px]  
       leading-[24px] md:text-[18px] md:leading-[28px] sm:text-[12px] 
       sm:leading-[18px] text-white `}>
                        <span className="text-[#30BC89] font-[600]
        lg:font-[600]"> Oops! </span>{message}</p>
                </div>}

            {props?.type === t('fraud_protection') &&
                <>
                    {message &&
                        <div className="flex sm:mx-0 mx-8">
                            <img src={Oops} alt="" className="md:w-[20px] md:h-[20px] w-[14px]
        h-[14px] mt-1" />
                            <p className={`font-hanken-grotesk md:font-[700] sm:font-[600] font-[500] text-[16px]
       leading-[24px] md:text-[18px] md:leading-[28px] sm:text-[12px] ${kudzuPlusTrue ? 'text-white' : ''}
       sm:leading-[18px] text-secondary-3 `}>
                                <span className="text-[#30BC89] font-[600] ml-2 
        lg:font-[600]"> {t("oops_exclamation")} </span>{message}</p>
                        </div>
                    }
                    {!startTimer &&
                        <div className=" flex flex-row items-center gap-2">
                            <span className=" text-secondary">
                                <img src={TimerIcon} className="md:w-[20px] md:h-[20px] sm:w-[14px] sm:h-[14px] w-[14px] h-[14px]"  alt="" />
                            </span>
                            <button type="button" className="font-hanken-grotesk font-[600] text-[16px] sm:text-[12px]
             leading-[24px] md:text-[18px] sm:leading-[18px]
             md:leading-[28px] text-[#2965FB] self-start active:opacity-80 transition-opacity duration-200"
                                onClick={handleResendCodeForCIP}
                            >{t("cip_resend_code")}</button>
                        </div>
                    }
                </>

            }
            {message == "" && <div className=" flex flex-row gap-3 items-center md:mb-28 sm:mb-12 mb-28 mt-5">
                <span className={`text-secondary ${props?.type === t('fraud_protection') && !startTimer && 'hidden'}`} >
                    <img src={TimerIcon} className="md:w-[20px] md:h-[20px] sm:w-[14px] sm:h-[14px] w-[14px] h-[14px]"  alt="" />
                </span>
                <p className={`font-hanken-grotesk lg:text-md md:text-[14px] sm:text-[12px] ${(props?.type == t('upgrade_to_kduzu_plus') || props?.type == t('downgrad_to_kudzu_plus')) ? 'text-white' : 'text-[var(--modal-text-heading-clr)]'} text-[14px] leading-7 font-[500] cursor-pointer pointer-events-none`}>
                    {props?.type === t('fraud_protection') ? ((startTimer) ? `Resend code in: 00:${String(timer).padStart(2, '0')}` : '') : t("security_check_notification")}
                </p>
            </div>}
            {!(props?.accessParam) &&
                <p className={`font-hanken-grotesk lg:text-md md:text-[14px] sm:text-[12px] text-[16px] ${(props?.type == t('upgrade_to_kduzu_plus') || props?.type == t('downgrad_to_kudzu_plus')) ? 'text-white' : 'text-[var(--modal-text-heading-clr)]'} leading-7 font-[500]`}>
                    {props?.selected2FAType ? (props?.selected2FAType == 'Email') ? t("didnt_recieve_email") : ((props?.selected2FAType == 'Text') && t("security_check_subheading2")) : t("security_check_subheading2")}{" "}
                    <button type="button" className='font-hanken-grotesk text-[#2965FB] font-semibold cursor-pointer active:opacity-80 transition-opacity duration-200' onClick={resendVerificationCode}>
                        {t("try_again")}
                    </button>
                    {props?.type === t('secured_credit_card') &&
                        <span className={`font-hanken-grotesk lg:text-md md:text-[14px] sm:text-[12px] text-[16px] ${(props?.type == t('upgrade_to_kduzu_plus') || props?.type == t('downgrad_to_kudzu_plus')) ? 'text-white' : 'text-[var(--modal-text-heading-clr)]'} leading-7 font-[500] font-semibold`}>&nbsp;{t("or")}&nbsp;
                            <button type="button" className='font-hanken-grotesk text-[#2965FB] font-semibold cursor-pointer active:opacity-80 transition-opacity duration-200' onClick={resendVerificationCode}>
                                {t("CANCEL_ACTIVATION")}
                            </button>
                        </span>
                    }
                    <span className={` ${(props?.type == t('upgrade_to_kduzu_plus') || props?.type == t('downgrad_to_kudzu_plus')) ? 'text-white' : 'text-[var(--dot-color)]'}  `}>.</span>
                </p>
            }
            {bottomText &&
                <p className="text-[var(--modal-text-heading-clr)] md:pt-5 pt-2 lg:text-[12px] md:text-[11px] sm:text-[10px] text-[11px] font-hanken-grotesk font-[400px] sm:font-medium  md:leading-[20px] leading-[17px]">
                    {t("CUSTOME_TWO_FA")}
                    <span className="text-[#2965FB] font-hanken-grotesk text-[14px] font-[600] cursor-pointer" onClick={() => { window.open(CONTACT_US_URL, "_blank"); }}> {t("Customer Care.")} </span>
                    {/* {t("help_number")}
                <span className="text-[#30BC89]"> {t("stop")} </span>
                {t("Message_frequency_varies")} */}
                </p>
            }
            {isLoading && <Loader />}
        </>
    );
};

export default Custom2FA;
